import React, { useEffect, useRef, useState } from 'react';

import Addform from './Addform';
import Switch from './Utils/Switch';
import Budget from './Budget/Budget';
import List from './List';

import { currencyOptions } from '../data';
import { number } from 'yup/lib/locale';

const Main = () => {

  const importFromStorage = (type) => {
    const storageRaw = window.localStorage.getItem('items');
    if(!storageRaw || storageRaw === 'undefined') {
      return [];
    }
    const savedStorage = JSON.parse(window.localStorage.getItem('items'));
    if(savedStorage === null) {
      return [];
    }
    const itemsToImport = savedStorage.filter(item => item.type === type);
    return itemsToImport;
  }

  const deleteFromStorage = (id) => {
    const storage = window.localStorage.getItem('items');
    if(storage) {
      const storageJSON = JSON.parse(storage);
      const newStorage = storageJSON.filter(item => item.id !== id);
      window.localStorage.setItem('items', JSON.stringify(newStorage));
    }
  };

  const [expenses, setExpenses] = useState(importFromStorage('expense')
  //   {
  //     type: "expense",
  //     title: 'Car repair',
  //     amount: 100,
  //     category: 'car',
  //     id: "543267"
  //   },
  //   {
  //     type: "expense",
  //     title: 'House rental',
  //     amount: 2200,
  //     category: 'bills',
  //     id: "65421"
  //   },
  //   {
  //     type: "expense",
  //     title: 'Visiting family',
  //     amount: 250,
  //     category: 'travel',
  //     id: "54327"
  //   },
  //   {
  //     type: "expense",
  //     title: 'Shopping',
  //     amount: 60,
  //     category: 'shopping',
  //     id: "12374"
  //   },
  );
  const [incomes, setIncomes] = useState(importFromStorage('income')


    // {
    //   type: "income",
    //   title: 'Anything',
    //   amount: 600,
    //   category: 'part time job',
    //   id: "43278"
    // },
    // {
    //   type: "income",
    //   title: 'Work',
    //   amount: 6000,
    //   category: 'main salary',
    //   id: "33674"
  //   },
  );
  
  
  const [totalBalance, setTotalBalance] = useState(0);
  
  const calculateBalance = () => {

    let totalExpenses;
    if(!expenses) {
      totalExpenses = 0;
    }
    else {
      totalExpenses = expenses.reduce((total, expense) => total += Number.parseInt(expense.amount), 0);
    }

    let totalIncomes;
    if(!incomes) {
      totalIncomes = 0;
    }
    else {
      totalIncomes = incomes.reduce((total, income) => total += Number.parseInt(income.amount), 0);
    }
    
    const totalBalance = totalIncomes - totalExpenses;
    console.log(totalBalance);
    setTotalBalance(totalBalance);
    console.log("balance calculated!");
    return totalBalance;
  }
  useEffect(() => {
    calculateBalance();
  }, [incomes, expenses])

  const handleAddClick = (e) => {
    const button = document.querySelector('.switch > .button');
    const overlay = document.querySelector('.overlay');
    const target = document.querySelector('.switch').dataset.for;
    const popup = document.getElementById(target);
    if (button.classList.contains('off')) {
      button.classList.remove('off');
      button.classList.add('on');
      overlay.classList.add('visible');
      popup.classList.add('visible');
    } else {
      button.classList.remove('on');
      button.classList.add('off');
      overlay.classList.remove('visible');
      popup.classList.remove('visible');
    }
  };

  const deleteItem = (e) => {
    const type = e.currentTarget.closest('.listItem').dataset.type;
    const id = e.currentTarget.closest('.listItem').id;
    let newState = [];
    console.log(type);
    if(type === 'expense') {
      setExpenses((prevState) => {
        console.log(prevState);
         newState = prevState.filter(item => item.id !== id);
        console.log("set expense");
        console.log(id);
        // console.log(item.id);
        return newState;
      });
    }
    else {
      setIncomes((prevState) => {
         newState = prevState.filter(item => item.id !== id);
         console.log("new state: ",newState);
         console.log("set income");
         return newState;
      });
    }

    //update localStorage as well:
    console.log("dochodzi a new state to:", newState);

    deleteFromStorage(id);
    return newState;

  }

  // Calculate on first render too
  const firstRender = useRef(true);
  useEffect(() => {
    if(firstRender.current === true) {
      firstRender.current = false
      calculateBalance();
    }
  }, []);

  return (
    <>
      <Budget currencyOptions={currencyOptions} totalBalance={totalBalance} />
      <Switch for="adder" handleAddClick={handleAddClick} />
      <Addform calculateBalance={calculateBalance} id="adder" setIncomes={setIncomes} setExpenses={setExpenses} />

      <div className="wrapper">
        <List calculateBalance={calculateBalance} deleteItem={deleteItem} items={expenses}>Expenses</List>
        <List calculateBalance={calculateBalance} deleteItem={deleteItem} items={incomes}>Incomes</List>
      </div>
    </>
  );
};

export default Main;
